import { Typography } from "@mui/material";

export const getConfigColumns = ({ onEdit }) => [
  {
    accessorKey: "configKey",
    header: () => "Key",
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500} fontFamily="monospace">
        {row.original.configKey ?? "N/A"}
      </Typography>
    ),
  },
  {
    accessorKey: "value",
    header: () => "Value",
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={600}>
        {String(row.original.value ?? "N/A")}
      </Typography>
    ),
  },
  {
    accessorKey: "valueType",
    header: () => "Type",
    cell: ({ row }) => (
      <Typography fontSize="0.82rem" color="text.secondary">
        {row.original.valueType ?? "N/A"}
      </Typography>
    ),
  },
  {
    accessorKey: "description",
    header: () => "Description",
    cell: ({ row }) => (
      <Typography fontSize="0.82rem" color="text.secondary">
        {row.original.description ?? "—"}
      </Typography>
    ),
  },
  {
    id: "actions",
    header: () => "Action",
    cell: ({ row }) => (
      <Typography
        onClick={(e) => { e.stopPropagation(); onEdit?.(row.original); }}
        sx={{ fontSize: "0.82rem", fontWeight: 600, color: "primary.main", cursor: "pointer" }}
      >
        Edit
      </Typography>
    ),
  },
];